// extracted by mini-css-extract-plugin
export default {"input":"input--yn2Jf"};